export default {
  init($element) {

  },
  finalize($element) {
    // Todo proper animation
    setTimeout(() => {
      $element.find('.circle-inner').removeClass('zero');
    }, 3000);
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/solution/statistic.js